import React from 'react'
import { SortableTableHeader } from '../../../../app/components/statelessDataTable/components/tableColumn'
import { StyledLink } from '../../../../theme/Global'
import { COMMON_TABLE_HEADERS } from '../../../constants'

const NotificationsAddressColumns = ({ isMinWage, sortOptions, eventHandlers }) => {
  const path = isMinWage ? 'minWage' : 'paidLeave'

  return ([
    {
      Header: () => (
        <SortableTableHeader
          field="name"
          text={COMMON_TABLE_HEADERS.LOCATION_NAME}
          sortOptions={sortOptions}
          eventHandlers={eventHandlers}
        />
      ),
      accessor: 'name',
      width: 350,
      minWidth: 350, // default
      maxWidth: 0, // default
      Cell: ({ cell }) => (
        <StyledLink to={`/${path}/details/${cell.row.original.id}`}>
          {cell.row.original.name}
        </StyledLink>
      ),
      canSort: false
    },
    {
      Header: () => (
        <SortableTableHeader
          field="address"
          text={COMMON_TABLE_HEADERS.ADDRESS}
          sortOptions={sortOptions}
          eventHandlers={eventHandlers}
        />
      ),
      accessor: 'address',
      width: 450,
      minWidth: 450, // default
      maxWidth: 0, // default
      Cell: ({ cell }) => <div className="text">{cell.row.original.address}</div>,
      canSort: false
    }
  ])
}

export default NotificationsAddressColumns
